import { captureUserFacingError } from '$utils/captureUserFacingError';

function setSuccessMessage(type, messages) {
	this.$notify({
		group: 'mms-notifications',
		type: 'success',
		text: messages[type],
	})
}

function setErrorMessage(type, errors, error, context = {}) {
	const text = errors[type];

	this.$notify({
		group: 'mms-notifications',
		type: 'error',
		text,
	})

	captureUserFacingError(text, error, {
		errorType: type,
		...context,
	});
}

export { setSuccessMessage, setErrorMessage };
